import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchSubmittalModel } from 'src/app/shared/model/SearchSubmittal.model';
import { PagedSubmittalList } from 'src/app/services/project/paged-submittal-list';
import { KeyValueItem } from '../KeyValueItem';
import { BaseService } from '../base.service';
import { IAppConfig } from '../Config/app-config.model';
import { SubmittalModel } from 'src/app/shared/model/submittal.model';

@Injectable({
  providedIn: 'root'
})
export class SubmittalService extends BaseService {
  eeaNumber: string;
  projectName: string;

  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
  }

  GetSubmittalsByProject(searchModel: SearchSubmittalModel): Observable<PagedSubmittalList> {
    let QueryStr = '';

    QueryStr =
      this.FilterProjectId(searchModel.projectId,
        QueryStr);

    let sortFilter = '';


    if (searchModel.sort !== null) {
      sortFilter = searchModel.sort.getSortQueryString(
        this.GetSortColumnMapping().find(k => k.Key === searchModel.sort.sortColumn).Value);
    }

    return this.Get<PagedSubmittalList>(
      `${this.configParam.ApiConfig.API_ENDPOINT}Submittal/searchBySpecificProject?${QueryStr}PageSize=${searchModel.pageSize}&Page=${searchModel.page}${sortFilter}`);

  }

  GetSubmittal(submittalId: string): Observable<SubmittalModel> {
    return this.Get<SubmittalModel>(`${this.configParam.ApiConfig.API_ENDPOINT}Submittal/${submittalId}`);
  }

  private FilterProjectId(projectId: string, QueryStr: string): string {
    if (projectId && projectId.length > 0) {
      QueryStr += 'ProjectId=' + projectId + '&';
    }
    return QueryStr;
  }

  GetSortColumnMapping(): KeyValueItem[] {
    return [
      new KeyValueItem('EEANo', '0'),
      new KeyValueItem('Project Name', '1'),
      new KeyValueItem('Location', '2'),
      new KeyValueItem('Submittal Type', '3'),
      new KeyValueItem('Publish Date', '4'),
      new KeyValueItem('Review Due Date', '5'),
      new KeyValueItem('Analyst', '6'),
      new KeyValueItem('Status', '7'),
      new KeyValueItem('Action Date', '8')
    ];
  }

  setEeaNumber(eeaNumber: string) {
    this.eeaNumber = eeaNumber;
  }

  setProjectName(project: string) {
    this.projectName = project;
  }

  getEeaNumber() {
    return this.eeaNumber == undefined ? "" : this.eeaNumber;
  }

  getProjectName() {
    return this.projectName == undefined ? "" : this.projectName;
  }

}
